import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/administrator');

export const maintenance = actionCreator<void>('MAINTENANCE');
export const backup = actionCreator<void>('BACKUP');
